export default __webpack_public_path__ + "static/media/Partner22Mobile.4b48ff11.jpeg";